import { render, staticRenderFns } from "./TranslationsRemoveButton.vue?vue&type=template&id=14c85408&"
import script from "./TranslationsRemoveButton.vue?vue&type=script&lang=js&"
export * from "./TranslationsRemoveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports